import { render, staticRenderFns } from "./CalculatorIcon.vue?vue&type=template&id=38b05d28&"
import script from "./CalculatorIcon.vue?vue&type=script&lang=js&"
export * from "./CalculatorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports